import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDateIssued = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "dateIssued",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16867",
		"data-name": "Group 16867",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12498",
				"data-name": "Path 12498",
				d: "M16,2V6",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12499",
				"data-name": "Path 12499",
				d: "M8,2V6",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12500",
				"data-name": "Path 12500",
				d: "M3,9H21",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12501",
				"data-name": "Path 12501",
				d: "M19,4H5A2,2,0,0,0,3,6V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V6A2,2,0,0,0,19,4Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12502",
				"data-name": "Path 12502",
				d: "M9,9V21",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12503",
				"data-name": "Path 12503",
				d: "M15,9V21",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12504",
				"data-name": "Path 12504",
				d: "M3,15H21",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12505",
		"data-name": "Path 12505",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgDateIssued;
